import { LitElement } from "lit";
import { globalState } from "../lib/globa-state";
import { state } from "lit/decorators.js";

class BaseComponent extends LitElement {
    @state()
    lang: string = "";

    constructor() {
        super();
        const defaultLang = navigator.language;
        if (defaultLang.includes("en")) {
            this.lang = localStorage.getItem("lang") ?? globalState.getState("lang") ?? "en";
        } else {
            this.lang = localStorage.getItem("lang") ?? globalState.getState("lang") ?? "sk";
        }
    }

    connectedCallback() {
        super.connectedCallback();
        globalState.subscribe("lang", this.handleGlobalLangChange.bind(this));

        if (!globalState.getState("lang")) {
            globalState.setState("lang", this.lang);
        }
        if (!localStorage.getItem("lang")) {
            localStorage.setItem("lang", this.lang);
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        globalState.unsubscribe("lang", this.handleGlobalLangChange.bind(this));
    }

    handleGlobalLangChange() {
        this.lang = globalState.getState("lang");
    }
}

export { BaseComponent };
